import React from 'react'

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-body">
            </div>
        </footer>
    )
}

export default Footer
